var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ma-2 btn-back",attrs:{"fab":"","small":"","color":"rgba(255, 255, 255, 0.90)"},on:{"click":function($event){return _vm.pushBack()}}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(" keyboard_backspace ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }